import { useCallback } from 'react';

import type { InspoImportSaveSummary } from '@/components/InspoImport/inspoImportTypes';
import { TripImportFlow } from '@/components/TripImport/TripImportFlow';
import { useTripImport } from '@/contexts/TripImportContext';

export default function TripImportRouteModalHost() {
  const { isOpen, prefilledText, entry, onCompleteSave, closeTripImport, clearPrefilledText } =
    useTripImport();

  const handleClose = useCallback(() => {
    closeTripImport();
  }, [closeTripImport]);

  const handleCompleteSave = useCallback(
    (summary: InspoImportSaveSummary) => {
      closeTripImport();
      onCompleteSave?.(summary);
    },
    [closeTripImport, onCompleteSave],
  );

  if (!isOpen) {
    return null;
  }

  return (
    <TripImportFlow
      isModal
      entry={entry}
      prefilledText={prefilledText}
      clearPrefilledText={clearPrefilledText}
      onRequestClose={handleClose}
      onCompleteSave={onCompleteSave ? handleCompleteSave : undefined}
    />
  );
}
